import {lazy} from 'react';

export const FooterLazy = lazy(() => import(/* webpackChunkName: "footer" */ '.'));
export const FooterAuthorLazy = lazy(() => import(/* webpackChunkName: "footerAuthor" */ './footerAuthor'));
